"use strict";
(function (ModalDismissReasons) {
    ModalDismissReasons[ModalDismissReasons["BACKDROP_CLICK"] = 0] = "BACKDROP_CLICK";
    ModalDismissReasons[ModalDismissReasons["ESC"] = 1] = "ESC";
})(exports.ModalDismissReasons || (exports.ModalDismissReasons = {}));
var ModalDismissReasons = exports.ModalDismissReasons;
//# sourceMappingURL=modal-dismiss-reasons.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/modal/modal-dismiss-reasons.js
// module id = 56
// module chunks = 0